import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 1.6rem;
    @media (max-width: 1024px) {
      gap: 0.5rem;
    }
    > p {
      font-size: ${theme.font.sizes.large};
      color: ${theme.colors.neutral.neutral120};
      margin-bottom: 0;
    }
  `}
`;
